var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row mb-5"},[_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"border rounded",class:_vm.theme == 'light' ? 'bg-white' : 'border-info '},[_c('div',{staticClass:"card-body"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-5"},[_c('h4',{staticClass:"card-title mb-4"},[_vm._v(" "+_vm._s(_vm.$t("dashboards.report-statistics"))+" ")])]),_c('div',{staticClass:"col-4"},[(_vm.dailyReportInterval == 'date-range')?_c('div',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-5 px-1"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.start_range),expression:"start_range"}],staticClass:"form-control",attrs:{"type":"date","id":"class"},domProps:{"value":(_vm.start_range)},on:{"input":function($event){if($event.target.composing){ return; }_vm.start_range=$event.target.value}}})]),_c('div',{staticClass:"col-5 px-1"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.end_range),expression:"end_range"}],staticClass:"form-control",attrs:{"type":"date","id":"class"},domProps:{"value":(_vm.end_range)},on:{"input":function($event){if($event.target.composing){ return; }_vm.end_range=$event.target.value}}})]),_c('div',{staticClass:"col-2"},[_c('b-button',{staticClass:"btn btn-block btn-success text-white",on:{"click":function($event){return _vm.getDailyReports()}}},[_c('span',{staticClass:"text-white"},[_vm._v(" "+_vm._s(_vm.$t("dashboards.apply")))])])],1)])]):_vm._e()]),_c('div',{staticClass:"col-3"},[_c('div',{staticClass:"d-flex"},[_c('div',{staticClass:"d-flex"},[_c('b-button',{staticClass:"mr-2",attrs:{"variant":_vm.charttype == 'line' ? 'primary' : 'outline-primary',"size":"sm","title":"Line Chart"},on:{"click":function($event){return _vm.changeType('line')}}},[_c('i',{staticClass:"bx bxs-chart font-size-24 align-middle"})]),_c('b-button',{staticClass:"mr-2",attrs:{"variant":_vm.charttype == 'bar' ? 'primary' : 'outline-primary',"size":"sm","title":"Bar Chart"},on:{"click":function($event){return _vm.changeType('bar')}}},[_c('i',{staticClass:"bx bxs-bar-chart-square font-size-24 align-middle"})])],1),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.dailyReportInterval),expression:"dailyReportInterval"}],staticClass:"form-control",attrs:{"id":"exampleFormControlSelect1"},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.dailyReportInterval=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},_vm.getDailyReports]}},[_c('option',{attrs:{"value":"7d"}},[_vm._v(_vm._s(_vm.$t("malware.last-7")))]),_c('option',{attrs:{"value":"30d"}},[_vm._v(_vm._s(_vm.$t("malware.last-30")))]),_c('option',{attrs:{"value":"3m"}},[_vm._v(_vm._s(_vm.$t("malware.last-90")))]),_c('option',{attrs:{"value":"date-range"}},[_vm._v(" "+_vm._s(_vm.$t("dashboards.date-range"))+" ")])])])])]),(_vm.loading.reportstatistic)?_c('div',[_vm._m(0)]):_vm._e(),(!_vm.loading.reportstatistic)?_c('div',[_c('apexchart',{staticClass:"apex-charts",attrs:{"height":"380","type":_vm.charttype,"dir":"ltr","series":_vm.reportStatistics.series,"options":{
              legend: {
                show: true,
                showForSingleSeries: false,
                showForNullSeries: true,
                showForZeroSeries: true,
                position: 'bottom',
                horizontalAlign: 'center',
                floating: false,
                fontSize: '14px',
                fontFamily: 'Helvetica, Arial',
                fontWeight: 400,
                formatter: undefined,
                inverseOrder: false,
                width: undefined,
                height: undefined,
                tooltipHoverFormatter: undefined,
                customLegendItems: [],
                offsetX: 0,
                offsetY: 0,
                labels: {
                  colors: '#fff',
                  useSeriesColors: false,
                },
                markers: {
                  width: 12,
                  height: 12,
                  strokeWidth: 0,
                  strokeColor: '#fff',
                  fillColors: undefined,
                  radius: 12,
                  customHTML: undefined,
                  onClick: undefined,
                  offsetX: 0,
                  offsetY: 0,
                },
                itemMargin: {
                  horizontal: 5,
                  vertical: 4,
                },
                onItemClick: {
                  toggleDataSeries: true,
                },
                onItemHover: {
                  highlightDataSeries: true,
                },
              },
              chart: {
                zoom: {
                  enabled: true,
                },
                toolbar: {
                  show: true,
                },
                redrawOnParentResize: true,
              },
              colors: ['#E2A040', '#53A9DA', '#E7515A', '#009688'],
              dataLabels: {
                enabled: false,
              },
              stroke: {
                curve: 'smooth',
                width: [2, 2, 2],
              },
              title: {
                text: 'Daily Comulative Report',
                align: 'left',
              },
              markers: {
                size: 0,

                hover: {
                  sizeOffset: 6,
                },
              },
              xaxis: {
                categories: _vm.reportStatistics.categories,
              },
              yaxis: {
                labels: {
                  formatter: function (val) {
                    return val.toFixed(0);
                  },
                },
              },
              grid: {
                show: true,
                strokeDashArray: 0.3,
                borderColor: '#000', // you can either change hear to disable all grids
                xaxis: {
                  lines: {
                    show: false, //or just here to disable only x axis grids
                  },
                },
                yaxis: {
                  lines: {
                    show: true, //or just here to disable only y axis
                  },
                },
              },
            }}})],1):_vm._e()])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-center py-4 my-5"},[_c('i',{staticClass:"bx bx-loader-circle bx-spin bx-md"}),_vm._v(" "),_c('br'),_c('span',{staticClass:"font-size-16"},[_vm._v(" Loading ... ")])])}]

export { render, staticRenderFns }